module.exports = __webpack_public_path__ + "img/icon-commemorate-flower.8a98c474.png";